import * as React from "react";
import {useEffect} from "react";
import {LocationCodeOverlay} from "./LocationCodeOverlay";
import {SignupDialog} from "./SignUpDialog";
import {AccessLockerDialog} from "./AccessLockerDialog";
import {classNames, createTheme, layout, PushButton, useFlag, useIdle, View, ViewContent} from "@variocube/cube-ui";
import {stylesheet} from "typestyle";
import {UtilizationOverlay} from "./UtilizationOverlay";
import {useLocalization} from "../../i18n";


const theme = createTheme({
    colorBackground: "#444",
    colorForeground: "#fff",
    colorPrimary: "#f08721",
});

export function FreeApp() {
    const {t} = useLocalization();
    const [signup, setSignup, clearSignup] = useFlag(false);
    const [locker, setLocker, clearLocker] = useFlag(false);

    const idle = useIdle(30);
    useEffect(() => {
        if (idle) {
            clearSignup();
            clearLocker();
        }
    }, [idle]);

    return (
        <View className={theme}>
            <ViewContent className={classNames(layout.horizontal, layout.center, layout.alignCenter)}>
                <div className={styles.main}>
                    <h1 className={styles.heading}>{t("SignUpTitle")}</h1>
                    <p>{t("SignUpIntro")}</p>
                    <PushButton primary onClick={setSignup}>{t("EnterPhoneNumber")}</PushButton>
                    <p className={styles.infoSmall}>{t("SignUpLinkInfo")}</p>
                </div>
                <div className={styles.openWithAccessCode}>
                    <PushButton onClick={setLocker}>{t("OpenWithAccessCode")}</PushButton>
                </div>
            </ViewContent>
            <UtilizationOverlay />
            <LocationCodeOverlay />
            <SignupDialog open={signup} onClose={clearSignup} />
            <AccessLockerDialog open={locker} onClose={clearLocker} />
        </View>
    );
}

const styles = stylesheet({
    main: {
        textAlign: "center",
        maxWidth: "18em"
    },
    heading: {
        fontSize: "1.5em",
        fontWeight: 500,
    },
    infoSmall: {
        fontSize: "0.875em",
    },
    openWithAccessCode: {
        position: "absolute",
        right: "1em",
        bottom: "1em",
    }
})


